import { render, staticRenderFns } from "./FormMultiFileUploaderGenericFileModule.vue?vue&type=template&id=cf0acd88&"
import script from "./FormMultiFileUploaderGenericFileModule.vue?vue&type=script&lang=ts&"
export * from "./FormMultiFileUploaderGenericFileModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports